// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import vueResource from 'vue-resource'
import store from './store'
import jquery from 'jquery'
import App from './App'
import router from './router'
import API from './assets/js/api'

//引入表单验证插件
import validate from './validate'
//引入muse-ui框架
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import 'muse-ui/dist/theme-light.css'
import 'assets/css/theme-66nao.css'
Vue.use(MuseUI);

window.VERSION = require('./const-branch-name');
window.g_k_urls = {
  WAB: GLOBAL.WABURL,
};
//断网提示
const ah = require("ajax-hook")
ah.hookAjax({
  open: function (a) {
    a[2] = true
  },
  send: function () {
    this.xhr.timeout =GLOBAL.timeout;
    this.xhr.ontimeout = function () {
      var oHttp = document.querySelector('#httpEventBox');
      oHttp.style.top = "0px";
      oHttp.style.transition = 'top 1s ease';
      return true;
    }
  },
  onload:function(xhr){
     var oHttp = document.querySelector('#httpEventBox');
     oHttp.style.top = "-60px";
  },
  onerror:function(xhr){
    var oHttp = document.querySelector('#httpEventBox');
    oHttp.style.top = "0px";
    oHttp.style.transition = 'top 1s ease';
  }

})

// 0. 如果使用模块化机制编程，導入Vue和VueRouter，要调用 Vue.use(VueRouter)
Vue.use(vueResource);  // 后台ajax请求
Vue.use(API);  // 接口
Vue.http.options.emulateJSON = true; // 设置数据提交的方式为formData

// 添加双月显示的插件begin
import 'vue-bimonthly-calendar/dist/style.css'
import vueBimonthlyCalendar from 'vue-bimonthly-calendar'
Vue.use(vueBimonthlyCalendar, {locale: 'zh'}) //locale can be 'zh' , 'en'
// 添加双月显示的插件end

//断网提示
// const ah = require("ajax-hook")
// ah.hookAjax({
//     open:function(a){
//       a[2] = true
//     },
//     send:function(){
//       this.xhr.timeout = 6000;             
//        this.xhr.ontimeout = function () {
//          console.log('网络连接中断')
//          var oHttp = document.querySelector('#httpEventBox')
//          oHttp.classList.add('httpEventBox-animation')
//          setTimeout (function () {
//            oHttp.classList.remove('httpEventBox-animation')
//          } ,3000)
//          return true
//        }
//     }
//   })
// 在请求发送前添加认证信息
//
let args = {};
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', 'Bearer ' + localStorage.access_token);
  request.headers.set('Accept', 'application/json');
  next(res => {
    let vm = args.vm;
    if (res.status === 401) 
    {
      let is_login = window.is_login;
      delete window.is_login;
      if (vm.$route.path === '/login')
      {
        return;
      }
      if (is_login)
      {
        console.log("timeout");
        router.push('/timeoutPage');
      }
      else
      {
        router.push('/login');
      }
      return;
    }
    if(res.status===502){
      router.push('/errorPage');
    }
    if (res.url === `/api/Users/me`)
    {
      window.is_login = true;
      return;
    }
    if (res.url === '/api/Auth/logout')
    {
      delete window.is_login;
      return;
    }
  })
});

fetch('/api/v2/system-preferences')
.then(r=>r.json())
.then(j=>
{
  window.g_system_preferences = j;
  // 4. 创建和挂载根实例。
  var vm = new Vue({
    router,
    store,
    validate,
    el: '#app',
    template: '<App/>',
    components: { App }
  });
  args.vm = vm;
  vm.$mount('#app');
})



// WEBPACK FOOTER //
// ./src/main.js